/** @format */

// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
  //email signup animation 
	if(document.getElementById('email-signup_email_address')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}
  window.onload = function () {
    /*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

    scrollDownAction(20, "scroll");

    scrollW();
    window.addEventListener("scroll", function () {
      scrollW();
    });
  };

  if(document.getElementsByClassName('js-blog-expand').length > 0){
    document.querySelectorAll('.js-blog-expand').forEach(btn => {
      btn.addEventListener('click', function(e){
          e.preventDefault();
          this.parentElement.classList.toggle('expanded');
          this.classList.toggle('expanded');
          if(this.classList.contains('expanded')){
            this.innerHTML = 'Read Less'
          } else {
            this.innerHTML = 'Read More'
          }
      });
  });
  }
  

  if(document.getElementsByClassName('js-map-item').length > 0){
    let allAirports = document.querySelectorAll('.js-map-item');
    allAirports.forEach(air => {
      air.addEventListener('click', function(){
        allAirports.forEach(item=> item.classList.remove('active'));
        this.classList.add('active')
      })
    });
  }

  $('.map-airports').slick({
    accessibility:false,
    fade:true,
    nextArrow:'#mapNext',
    prevArrow:'#mapPrev',
    adaptiveHeight:true
  });

  if($('.map-airports').length > 0){
    let allPins = document.getElementById('homeMapPins').querySelectorAll('.pin');
  
    $('.map-airports').on('afterChange', function(event, slick, currentSlide){
      allPins.forEach(pin => pin.classList.remove('active'));
      allPins[currentSlide].classList.add('active')
    });

    allPins.forEach(pin => {
      pin.addEventListener('click', function(){
        let currentSlide =  this.getAttribute('data-click');
        allPins.forEach(p => p.classList.remove('active'));
        this.classList.add('active');
        $('.map-airports').slick('slickGoTo',currentSlide);

      })
    });


  }
  


})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
